<div class="container">
  <div class="col-12">
    <h2 class="title-text" style="text-align: left">My Follow-up Questions</h2>
  </div>

  <div class="row mt-5">
    <div class="col-12 mb-4 d-none d-md-block d-lg-block">
      <div class="mat-elevation-z8 margin-bottom-20">
        <table
          mat-table
          matSort
          [dataSource]="questionnaires"
          (matSortChange)="sortData($event)"
        >
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>
              <span> Follow-up Questions </span>
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.questionnaireSchema.title }}
            </td>
          </ng-container>

          <ng-container matColumnDef="requesterName">
            <th
              mat-header-cell
              *matHeaderCellDef
              sortActionDescription="Sort by Subscriber Name / Requester Name"
            >
              <span>Requester Name</span>
            </th>
            <td mat-cell *matCellDef="let element">
              <span>
                {{ getFullName(element.provider) }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="createdAt">
            <th
              *matHeaderCellDef
              mat-header-cell
              mat-sort-header
              sortActionDescription="Sort by Created At"
            >
              Published On
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.createdAt | date: 'dd-MM-yyyy h:mm' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="answeredAt">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              sortActionDescription="Sort by Answer Submitted On"
            >
              <span> Answer Submitted On </span>
            </th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element.response?.createdAt">
                {{ element.response.createdAt | date: 'dd-MM-yyyy h:mm' }}
              </span>
              <span *ngIf="!element.response?.createdAt"> Pending </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="min-width-column">
              <button
                *ngIf="element.response"
                mat-stroked-button
                class="action-button next"
                (click)="viewAnswerForm(element)"
                [disabled]="isLoading"
              >
                View Responses
              </button>

              <button
                *ngIf="!element.response"
                mat-stroked-button
                class="action-button next"
                (click)="viewSubmissionForm(element)"
                [disabled]="isLoading"
              >
                Submit Answer
              </button>

              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                [disabled]="isLoading"
                [class.hidden]="!element.response"
                aria-label="Example icon-button with a menu"
              >
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu="matMenu" xPosition="after">
                <button mat-menu-item (click)="deleteResponse(element)">
                  <mat-icon
                    class="material-symbols-outlined"
                    style="color: #e35f6c"
                    >do_not_disturb_on_outlined
                  </mat-icon>
                  <span style="color: #e35f6c">Delete Answer</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <div class="mat-paginator-container">
          <div class="mat-paginator-range-label">
            {{ totalRecords }} Results Found
          </div>
          <div class="mat-paginator-navigation">
            <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>

            <button
              mat-button
              class="custom-page"
              [disabled]="pageNo === 0"
              (click)="goToPreviousPage()"
            >
              <mat-icon>arrow_left</mat-icon>
              Prev
            </button>
            <button
              mat-button
              class="custom-page"
              *ngFor="let pageNumber of getPageNumbers()"
              [disabled]="pageNumber === pageNo"
              (click)="goToPage(pageNumber)"
            >
              {{ pageNumber + 1 }}
            </button>
            <button
              mat-button
              class="custom-page"
              [disabled]="!totalRecords || pageNo === getTotalPages() - 1"
              (click)="goToNextPage()"
            >
              Next
              <mat-icon>arrow_right</mat-icon>
            </button>
          </div>
        </div>

        <mat-paginator
          style="visibility: hidden; display: none"
          [pageSize]="limit"
          [pageIndex]="pageNo"
          [length]="totalRecords"
          [disabled]="isLoading"
        >
        </mat-paginator>
      </div>
    </div>
  </div>

  <div *ngIf="error" class="text-danger text-center">
    {{ error }}
  </div>
</div>

<div
  class="modal fade p-0"
  id="open-question"
  tabindex="-1"
  role="dialog"
  aria-labelledby="patientToPatientLinkTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <mat-icon
          class="material-symbols-outlined"
          style="cursor: pointer; float: right"
          (click)="closeModal()"
          aria-hidden="false"
          aria-label="Example home icon"
          fontIcon="close"
        ></mat-icon>
      </div>
      <div class="modal-body">
        <survey [model]="surveyModel"></survey>
      </div>
    </div>
  </div>
</div>
